import React from 'react';
import { Box, Typography } from '@mui/material';
import Data from '../../Data/PersonalInfo.json';

//  @desc `ASHVIN C K`
const FullName = () => {
  return (
    <>
      {Data.name.map(({ firstName, lastName }) => (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-end',
          }}
          key={`${firstName}-${lastName}`}
        >
          <Typography
            variant='title'
            sx={{
              lineHeight: '0.8',
            }}
          >
            {firstName}
          </Typography>
          <Typography
            variant='title'
            sx={{
              lineHeight: '1.0',
            }}
          >
            {lastName}
          </Typography>
        </Box>
      ))}
    </>
  );
};

export default FullName;
